import { pathOr } from 'ramda';
import { IS_CLIENT } from '../constants';
const getOptions = (copyKey) => IS_CLIENT && pathOr(copyKey, ['hm', 'options', ...copyKey.split('.')], window);
export default getOptions;
//# sourceMappingURL=getOptions.js.map